export default {
  header: 'Anlagenparameterdefinitionen',
  subheader: 'Auf dieser Seite können benutzerdefinierte Anlagenparameter verwaltet werden, die im Signal-Builder wiederverwendet werden können.',
  empty: 'Keine Benutzerdefinierten Anlagenparameter sind definiert.',
  confirmDelete: {
    header: 'Parameter "{parameter}" löschen?',
    message: 'Mehrere Anlagen verwenden diese Definition möglicherweise. Dies kann nicht rückgängig gemacht werden.',
  },
};
